class ProductForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');   
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cartNotification = document.querySelector('cart-notification');
    this.submitButton = this.querySelector('[type="submit"]');
    this.stickyAddToCartBtn = document.querySelector('[data-type="sticky-add-cart"]') || null;
    this.asASubmitButton = document.querySelector('.product__info-container .ontime-block .button-as-addtocart');
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    const mutipleProdData = [];
    const timestamp = Math.round(new Date().getTime()/1000);
    if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
    this.handleErrorMessage();
    this.cartNotification.setActiveElement(document.activeElement);
    this.submitButton.setAttribute('aria-disabled', true);
    this.submitButton.classList.add('loading');
    this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
    if( this.asASubmitButton ){
      this.asASubmitButton.setAttribute('aria-disabled', true);
      this.asASubmitButton.classList.add('loading');
      this.asASubmitButton.querySelector('.loading-overlay__spinner').classList.remove('hidden');
    }

    /* ***practice plan product data*** */
    
    let onlyMemberActive = document.querySelector('.main-plans-box-wrapper') ? true : false;    
    const practicePlan = onlyMemberActive ? document.querySelector('.main-plans-box-wrapper') : (document.querySelector('.product__info-container .practice-plan .plans-block input[name="practice-plan"]:checked') || null);
    let mainPdId;
    if(practicePlan){
      mainPdId = onlyMemberActive ? Number(practicePlan.querySelector('.warranty-input-wrap').dataset.id) : Number(practicePlan.dataset.id);

      if(practicePlan.closest('.has-membership') || onlyMemberActive == true ){
        /* ***When Scanner&Membership option is selected then build this data object*** */
        
        //let memberShipPd = practicePlan.closest('.has-membership').querySelector('.billing-cycle select');
        //let memberShipYearPdId = Number(memberShipPd.options[memberShipPd.selectedIndex].value);
        //let memberShipYearSellingPlanId = Number(memberShipPd.options[memberShipPd.selectedIndex].dataset.sellingPlan);
        
        let memberShipYearPdId, memberShipYearSellingPlanId;
        if( onlyMemberActive ){
          memberShipYearPdId = Number(practicePlan.querySelector('.specialized-dropdown .specialized-drop-default').dataset.id);
          memberShipYearSellingPlanId = Number(practicePlan.querySelector('.specialized-dropdown .specialized-drop-default').dataset.sellingPlan);
        }else{
          memberShipYearPdId = Number(practicePlan.closest('.has-membership').querySelector('[data-name="billing-cycle"] .select .specialized-drop-default').dataset.id);
          memberShipYearSellingPlanId = Number(practicePlan.closest('.has-membership').querySelector('[data-name="billing-cycle"] .select .specialized-drop-default').dataset.sellingPlan);
        }

        const speciality_prop = localStorage.getItem("speciality");
      if(speciality_prop){
        if(mainPdId) mutipleProdData.push({id:mainPdId, quantity:1,properties:{"_ID":timestamp,"Packages": "Packages included", "_MainItem": "true", "_Speciality":speciality_prop }});
      }else{
        if(mainPdId) mutipleProdData.push({id:mainPdId, quantity:1,properties:{"_ID":timestamp,"Packages": "Packages included", "_MainItem": "true" }});
      }
        // if(memberShipYearPdId) mutipleProdData.push({id:memberShipYearPdId,	selling_plan: memberShipYearSellingPlanId, quantity:1,properties:{"_ID":timestamp}});
        if(memberShipYearPdId){
          if(document.querySelector('.main-plans-box-wrapper').querySelector('.specialized-dropdown .specialized-drop-default .p-name').textContent == 'One time membership'){
            mutipleProdData.push({id:memberShipYearPdId,quantity:1,properties:{"_ID":timestamp, "_onetime":true}}); 
          }else{
            mutipleProdData.push({id:memberShipYearPdId,	selling_plan: memberShipYearSellingPlanId, quantity:1,properties:{"_ID":timestamp}});  
          }
        }
      } else {
        /* ***When Only Scanner option is selected then build this data object*** */
        const speciality_prop = localStorage.getItem("speciality");
      if(speciality_prop){
        if(mainPdId) mutipleProdData.push({id:mainPdId, quantity:1,properties:{"_ID":timestamp, "_MainItem": "true", "_Speciality":speciality_prop}});
      }else{
        if(mainPdId) mutipleProdData.push({id:mainPdId, quantity:1,properties:{"_ID":timestamp, "_MainItem": "true"}});
        }
        /* ***Advance-package product data****  */
        const advancePackageData = document.querySelectorAll('.product__info-container .advance-package .package-item input[name="advance-package"]') || null;
        if(advancePackageData){
          advancePackageData.forEach((element) => {
            if(element.checked){
              let advPkgId = Number(element.dataset.id);
              let advPkgTitle = element.closest('.package-item').querySelector('.package-name').innerText.trim();
              mutipleProdData.push({id:advPkgId, quantity:1,properties:{"_ID": timestamp, "_Packages": advPkgTitle}});
            }
          });
        }
      }
    } else {
      /* ***if menbership product is not there then we will be stored main product data*** */
      mainPdId = Number(this.querySelector('form input[name="id"]').value);
      const speciality_prop = localStorage.getItem("speciality");
      if(speciality_prop){
        if(mainPdId) mutipleProdData.push({id:mainPdId, quantity:1,properties:{"_ID":timestamp, "_MainItem": "true", "_Speciality":speciality_prop }});
      }else{
        if(mainPdId) mutipleProdData.push({id:mainPdId, quantity:1,properties:{"_ID":timestamp, "_MainItem": "true"}});
      }

      /* ***Advance-package product data*** */
      const advancePackageData = document.querySelectorAll('.product__info-container .advance-package .package-item input[name="advance-package"]') || null;
      if(advancePackageData){
        advancePackageData.forEach((element) => {
          if(element.checked){
            let advPkgId = Number(element.dataset.id);
            let advPkgTitle = element.closest('.package-item').querySelector('.package-name').innerText.trim();
            mutipleProdData.push({id:advPkgId, quantity:1,properties:{"_ID":timestamp, "_Packages": advPkgTitle}});
          }
        });
      }
    }

    /* ***Accessories product data*** */
    const scannerAccessoriesData = document.querySelectorAll('.product__info-container .add-accessories .accessories-list .list-item input[name="accessories"]') || null;
    if(scannerAccessoriesData){
      for (let checkbox of scannerAccessoriesData) {

        if (checkbox.checked) {
          let accPdId = Number(checkbox.dataset.id);
          let accPdIdTitle = checkbox.closest('.list-item').querySelector('.item-name').innerText.trim();
          mutipleProdData.push({id:accPdId, quantity:1,properties:{"_ID":timestamp, "_Accessories": accPdIdTitle}});
        }

        /*
          ********
          1. check if recomnded accessories product is checked?
          2. if not, then we will show a popup of accessories product that have tag=RecommendedProduct
          3. We set counter attribute to popup button element. so when user click addToCart first time
             then we will show the recomnded popup. if user click addToCart again without page refresh then
             we will not show this popup again.
          **********
        */
        const recomndPopupEle = document.querySelector('body .product-popup-section-container a[href="#recommendation-popup"]') || null;
        if(recomndPopupEle){
          let counter = Number(recomndPopupEle.dataset.counter) || 0;
          if(checkbox.checked == false && checkbox.dataset.recomndedProduct === 'true' && counter === 0){
            recomndPopupEle.click();
            counter += 1;
            recomndPopupEle.setAttribute("data-counter", counter);
            console.log('recomnded product not added',counter);
            /* ***disabled addToCart loading*** */
            this.submitButton.classList.remove('loading');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
            
            /* ***disabled sticky addToCart loadind*** */
            if(this.stickyAddToCartBtn){
              this.stickyAddToCartBtn.classList.remove('loading');
              if (!this.error) this.stickyAddToCartBtn.removeAttribute('aria-disabled');
              this.stickyAddToCartBtn.querySelector('.loading-overlay__spinner').classList.add('hidden');
            }
            if( this.asASubmitButton ){            
              this.asASubmitButton.classList.remove('loading');
              if (!this.error) this.asASubmitButton.removeAttribute('aria-disabled');
              this.asASubmitButton.querySelector('.loading-overlay__spinner').classList.add('hidden');            
            }
            
            return false;
          }
        }

      }
    }
    
    
    /* ***Extended warranty product data*** */
    const extendedWarrantyEle = document.querySelector('.product__info-container .extended-warranty .warranty-care-wrapper') || null;
    const extendedWarrantyPdIdEle = document.querySelector('.product__info-container .extended-warranty .warranty-item input[name="warranty-care"]:checked') || null;
    if(extendedWarrantyEle){
      if(extendedWarrantyPdIdEle){
        let extendedWarranrtPdId = Number(extendedWarrantyPdIdEle.dataset.id);
        let extendedWarranrtPdTitle = extendedWarrantyPdIdEle.closest('.warranty-item').querySelector('.name').innerText.trim();
        if(!isNaN(extendedWarranrtPdId)){
          mutipleProdData.push({id:extendedWarranrtPdId, quantity:1,properties:{"_ID":timestamp, "_Warranty": extendedWarranrtPdTitle}});
        }
      } else {
        scroll({
          top: document.querySelector('.product__info-container .extended-warranty').offsetTop-95,
          behavior: "smooth"
        });
        if(!document.querySelector('.product__info-container .extended-warranty .error-msg')){
          let erroEle = document.createElement("p");
          erroEle.innerHTML = "This option is required";
          erroEle.classList = "error-msg";
          document.querySelector('.product__info-container .extended-warranty .warranty-care-wrapper').insertAdjacentElement("afterend", erroEle);
          let warrantyWrap = document.querySelector(".warranty-care-wrapper") || null;
          if(warrantyWrap){
            warrantyWrap.classList.add("error-active");
          }
          
        }
        /* ***disabled addToCart loading*** */
        this.submitButton.classList.remove('loading');
        if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        
        /* ***disabled sticky addToCart loadind*** */
        if(this.stickyAddToCartBtn){
          this.stickyAddToCartBtn.classList.remove('loading');
          if (!this.error) this.stickyAddToCartBtn.removeAttribute('aria-disabled');
          this.stickyAddToCartBtn.querySelector('.loading-overlay__spinner').classList.add('hidden');
        }
        if( this.asASubmitButton ){            
          this.asASubmitButton.classList.remove('loading');
          if (!this.error) this.asASubmitButton.removeAttribute('aria-disabled');
          this.asASubmitButton.querySelector('.loading-overlay__spinner').classList.add('hidden');            
        }
        
        return false;
      }
    }
    
    /* ***Add active class to sticky addToCart progress navigation*** */
    const stickyNavSelctor = document.querySelector('.product-navigation [data-nav-addtocart]') || null;
    stickyNavSelctor.classList.add('active');
    
    
    /* ***AddToCart All Selcted Products*** */
    const CART_NOTIFICATION_SECTION = this.cartNotification.getSectionsToRender().map((section) => section.id);
    const CART_NOTIFICATION_SECTION_URL = window.location.pathname;
    const ADDTOCART_OBJECT = { items: mutipleProdData.reverse(), sections: CART_NOTIFICATION_SECTION, sections_url: CART_NOTIFICATION_SECTION_URL };
    //console.log('ADDTOCART_OBJECT--',ADDTOCART_OBJECT);

    setTimeout((e) => {
      fetch(window.Shopify.routes.root+'cart/add.js', {
        method: 'POST',
        headers: { "Accept": "application/json", "Content-Type": "application/json" },
        body: JSON.stringify(ADDTOCART_OBJECT)
      })
      .then(response => response.json()).then(response => { 
        //console.log(response);
        if (response.status) {
          this.handleErrorMessage(response.description);
          const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
          if (!soldOutMessage) return;
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.querySelector('span').classList.add('hidden');
          soldOutMessage.classList.remove('hidden');
          this.error = true;
          return;
        }
        this.error = false;
        this.form.classList.contains('form-page') ? window.location.href = '/cart' : this.updateCartNotification(response);
      })
      .catch((error) => {
        console.error('Error:', error);
      })
      .finally((e) => {
        this.submitButton.classList.remove('loading');
        if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading-overlay__spinner').classList.add('hidden');        
        
        /* ***disabled sticky addToCart loadind*** */
        if(this.stickyAddToCartBtn){
          this.stickyAddToCartBtn.classList.remove('loading');
          if (!this.error) this.stickyAddToCartBtn.removeAttribute('aria-disabled');
          this.stickyAddToCartBtn.querySelector('.loading-overlay__spinner').classList.add('hidden');
        }
        if( this.asASubmitButton ){            
          this.asASubmitButton.classList.remove('loading');
          if (!this.error) this.asASubmitButton.removeAttribute('aria-disabled');
          this.asASubmitButton.querySelector('.loading-overlay__spinner').classList.add('hidden');            
        }
        
      });
    },250);
    
  }
  
  updateCartNotification(cart) {

    const notificationProductHtml = this.stringToHTML(cart.sections['cart-notification-product']);
    const notificationCartButtontHtml = this.stringToHTML(cart.sections['cart-notification-button']);
    const notificationCartCountHtml = this.stringToHTML(cart.sections['cart-icon-bubble']);

    this.cartNotification.querySelector('#cart-notification-product').innerHTML = notificationProductHtml.querySelector('.cart-item').innerHTML;
    this.cartNotification.querySelector('#cart-notification-button').innerHTML = notificationCartButtontHtml.querySelector('#shopify-section-cart-notification-button').innerHTML;
    document.querySelector('.header #cart-icon-bubble').innerHTML = notificationCartCountHtml.querySelector('#shopify-section-cart-icon-bubble').innerHTML;


    /*For package product div create and append to cart notification*/
    let pakgeDivEle = document.createElement("div");
    pakgeDivEle.innerHTML = `<h3 class="cart-notification-product__name">Software Packages Selected:</h3>`;
    pakgeDivEle.classList = "extra-products";
    /*For accessories product div create and append to cart notification*/
    let accDivEle = document.createElement("div");
    accDivEle.innerHTML = `<h3 class="cart-notification-product__name">Accessories Selected:</h3>`;
    accDivEle.classList = "extra-products";


    cart.items.reverse().forEach((item) => {

      if(item.selling_plan_allocation){
        let membershipProductTitle = item.title;
        let el = document.createElement("div");
        el.innerHTML = `<h3 class="cart-notification-product__name">Membership Selected:</h3><span>${membershipProductTitle}</span>`;
        el.classList = "extra-products";
        this.cartNotification.querySelector('#cart-notification-product .cart-notification-product-wrap').append(el);
      }

      /* Iterating through properties object and append this product title to main product content*/
      for (let key in item.properties) {
        if(key == '_Packages'){
          let pacakgesProductTitle = item.properties[key];
          let pakgeDivEleHtml = document.createElement("span");
          pakgeDivEleHtml.innerHTML = pacakgesProductTitle;
          pakgeDivEle.appendChild(pakgeDivEleHtml);
          this.cartNotification.querySelector('#cart-notification-product .cart-notification-product-wrap').appendChild(pakgeDivEle);
        }
        if(key == '_Accessories'){
          let accProductTitle = item.properties[key];
          let accDivEleHtml = document.createElement("span");
          accDivEleHtml.innerHTML = accProductTitle;
          accDivEle.appendChild(accDivEleHtml);
          this.cartNotification.querySelector('#cart-notification-product .cart-notification-product-wrap').appendChild(accDivEle);
        }
        if(key == '_Warranty'){
          let warrentyProductTitle = item.properties[key];
          let el1 = document.createElement("div");
          el1.innerHTML = `<h3 class="cart-notification-product__name">Extended warranty Selected:</h3><span>${warrentyProductTitle}</span>`;
          el1.classList = "extra-products";
          this.cartNotification.querySelector('#cart-notification-product .cart-notification-product-wrap').append(el1);
        }
      }

    });

    if(document.querySelector('sticky-header')) document.querySelector('sticky-header').reveal();
    this.cartNotification.open();

  }

  stringToHTML(str) {
    let parser = new DOMParser();
    let doc = parser.parseFromString(str, 'text/html');
    return doc.body;
  }

  handleErrorMessage(errorMessage = false) {
    this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
    if (!this.errorMessageWrapper) return;
    this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
    this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
    if (errorMessage) {
      this.errorMessage.textContent = errorMessage;
    }
  }

}

customElements.define('product-multi-add', ProductForm);